
class Owner {
    id: number;
    name: string;
}



export class Repository {
    id: string = "";
    code: string = "";
    title: string = "";
    img: string = "";
    description: string = "";
    background: string = "";
    logo: string = "";
    companyId: number = 1;
    owner: Owner;
    private_: boolean = false;
    editUsers: Owner[] = [];
    viewUsers: Owner[] = [];
    constraints: Owner[] = [];
}



